import IconAis from "@/assets/images/pages/privilege/topup/ais.png";
import IconDtac from "@/assets/images/pages/privilege/topup/dtac.png";
import IconMy from "@/assets/images/pages/privilege/topup/my.png";
import IconTrue from "@/assets/images/pages/privilege/topup/true.png";

export const carriersList = [
  {
    carrierId: 1,
    name: "AIS",
    icon: IconAis,
    value: [10,20,30,40,50,60,70,80,90,100,150,200,300,350,400,500,800,1000,1500],
  },
  {
    carrierId: 2,
    name: "DTAC",
    icon: IconDtac,
    value: [10,20,30,40,50,60,100,200,300,500,800],
  },
  {
    carrierId: 4,
    name: "TRUE",
    icon: IconTrue,
    value: [10,20,30,40,50,60,70,80,90,100,150,200,300,350,400,500,800,1000],
  },
  {
    carrierId: 8,
    name: "MY",
    icon: IconMy,
    value: [10,20,50,100,200,300,400,500],
  },
];

export const allValue = [10,20,30,40,50,60,70,80,90,100,150,200,300,350,400,500,800,1000,1500]
